import { BaseNode } from './base/BaseNode';

export class Text extends BaseNode {
  constructor() {
    super('text');
  }

  get schema() {
    return {
      group: 'inline',
    };
  }
}
